/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react'
import _ from 'lodash'
// import MCIcon from 'react-native-vector-icons/MaterialCommunityIcons'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import BasePaymentSubscriptionView from 'x/modules/subscription/BasePaymentSubscriptionView'
import { COLORS } from 'x/config/styles'
import CONS from 'x/config/constants'
import * as xFmt from 'x/utils/formatter'
import p from 'x/config/platform-specific'
import XCustomHeader from 'xui/components/XCustomHeader'
import ProfilePackage from 'xui/components/ProfilePackage'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XCapsuleSegment, { IOptionsCapsuleSegment } from 'xui/components/XCapsuleSegment'
import VStack from 'xui/components/VStack'
import XCard from 'xui/components/XCard'
import { TouchableOpacity, Clipboard, Linking } from 'react-native'
import * as util from 'x/utils/util'
import * as subscriptionUtil from 'x/utils/subscriptionUtil'
import assets from 'xui/assets'
import XIcon from 'xui/components/XIcon'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XButton from 'xui/components/XButton'
import XDocumentDropzone from 'xui/components/XDocumentDropzone'
import XDateTimeSinglePicker from 'xui/components/XDateTimeSinglePicker'
import XSpinner from 'xui/components/XSpinner'
import dayjs from 'dayjs'
import XCheckButton from 'xui/components/XCheckButton'
import XCountdownTimer from 'xui/components/XCountdownTimer'

// import { withIAPContext } from 'react-native-iap'
// import { createStackNavigator } from '@react-navigation/stack'
// const IMG_DISCOUNT = require('../../img/discount/discount_red.png')

// const BRONZ_BG = require('../../img/packge_bg/bronz.png')
// const SILVER_BG = require('../../img/packge_bg/silver.png')
// const GOLD_BG = require('../../img/packge_bg/gold.png')
// const PLATINUM_BG = require('../../img/packge_bg/platinum.png')

// const IMG_SCB = require('../../img/banks/scb.png')
const IMG_SCB = assets.images.banks.scb

const OPTIONS_NEW_SEGMENT: IOptionsCapsuleSegment[] = [
  {
    text: '1 เดือน',
  },
  {
    text: '3 เดือน',
    // labelView: <XImage source={IMG_DISCOUNT} w={50} h={50} />,
  },
  {
    text: '6 เดือน',
    // labelView: <XImage source={SILVER_BG} w={20} h={30} mt='2' />,
  },
  {
    text: '12 เดือน',
    // labelView: <XImage source={PLATINUM_BG} w={20} h={30} />,
  },
]

export default abstract class BaseUIPaymentSubscriptionView extends BasePaymentSubscriptionView {
  abstract _downloadQrImage(base64String: string): void
  _renderHeader = () => {
    const { mode } = this.state
    let title = 'ซื้อแพ็กเกจ'
    if (mode === 'add_on') {
      title = 'ซื้อแพ็กเกจเสริม'
    }
    if (mode === 'upgrade') {
      title = 'อัปเกรดแพ็กเกจ'
    }
    return (
      <XCustomHeader
        title={title}
        headerLeftProps={{
          backIcon: true,
          onPressItem: () => {
            // const params = this._getParams()
            // const { succeedPaymentCallBack } = params
            // if (_.isFunction(succeedPaymentCallBack)) {
            // succeedPaymentCallBack()
            // }
            this.goBack()
          },
        }}
        // renderHeaderRight={this._renderHeaderRight}
      />
    )
  }

  _renderProfile = () => {
    const { subscription } = this.props
    const { profile } = this.state
    // console.log('profile // => ', profile)
    if (_.isNil(profile) || _.isNil(subscription)) {
      return null
    }
    const typeId: number = subscription.has('type') ? subscription.get('type') : 0
    // console.log('profile => ', profile)
    return <ProfilePackage profile={profile} typeId={typeId} />
  }

  _renderTitleDescription = () => {
    const { pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return null
    }
    return (
      <HStack w='full' alignItems='center' justifyContent='center' mt='2' h='16'>
        <XText fontSize='lg' textAlign='center'>
          {'เลือกซื้อแพ็กเกจได้อย่างอิสระ\nในทุกแบบที่คุณต้องการ'}
        </XText>
      </HStack>
    )
  }

  _renderSelectedMonthPackage = () => {
    const { selectedOptionRangePackageIndex } = this.state
    return (
      <HStack px='2' mt='2'>
        <XCapsuleSegment
          options={OPTIONS_NEW_SEGMENT}
          onSegmentChange={(newIndex: number) => this.setState({ selectedOptionRangePackageIndex: newIndex })}
          sectedIndex={selectedOptionRangePackageIndex}
        />
      </HStack>
    )
  }

  _getAddOnCurrentPackageBySku = (sku: string) => {
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle)) {
      return null
    }

    const addOnlist = []
    const fullSku = currentPackageBillingCycle.find((addOn) => addOn.sku.startsWith(sku))?.sku
    // console.log('fullSku => ', fullSku)
    if (_.isNil(fullSku)) {
      return null
    }
    currentPackageBillingCycle.forEach((addOn) => {
      if (addOn.sku.startsWith(sku)) {
        addOnlist.push(addOn)
      }
    })
    return addOnlist.length > 0 ? addOnlist : null
  }

  // เอาไว้ render รายละเอียดแพ็กเสริม
  _renderAddOnCurrentPackageListDetail = (key: string, cutSku: string) => {
    // console.log('key => ', key)
    // console.log('cutSku => ', cutSku)
    const addOnPackageList = this._getAddOnCurrentPackageBySku(cutSku)
    // const diff = this._getDifferenceFromMainPackageAndNowPackage(key)
    const unit = util.getUnitNameByDataJsonKey(key)

    if (_.isNil(addOnPackageList)) {
      return null
    }
    // console.log('addOnPackageList => ', addOnPackageList)
    return (
      <VStack>
        {addOnPackageList.map((addOn) => {
          const { start_date, end_date, qty, sku } = addOn
          const addOnData = this._getCurrentSelectedAddOnDataByCutSku(sku)
          const { data_json } = addOnData
          const startPackage = dayjs(start_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          const endDataPackage = dayjs(end_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          return (
            <HStack w='full' key={addOn.sku}>
              <HStack flex={1}>
                <VStack>
                  <XText>{`มีแพ็กเสริมเพิ่ม ${data_json[key]} ${unit} x ${qty}`}</XText>
                  <XText variant='inactive' fontSize='xs'>
                    {`${startPackage} - ${endDataPackage}`}
                  </XText>
                </VStack>
              </HStack>
              <HStack flex={1} justifyContent='flex-end' alignItems='flex-start'>
                <XText>{`${data_json[key] * qty}`}</XText>
                <XText variant='inactive' fontSize='xs' ml='2' w='70px'>
                  {`${unit}`}
                </XText>
              </HStack>
            </HStack>
          )
        })}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderAddOnTitle = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { selectedMainPackage, mode } = this.state
    // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
    const newSelectedMainPackage = mode !== 'upgrade' ? _.cloneDeep(selectedMainPackage) : this._getMainPackageByUpgradePackageMode()
    const { data_json } = newSelectedMainPackage
    const value = !_.isNil(data_json) ? data_json[addOn.addOnKey] : 0
    const unit = util.getUnitNameByDataJsonKey(addOn.addOnKey)
    const packageName = util.getSubscriptionTypeFullNameBySubType(newSelectedMainPackage.item_subtype)
    // const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(addOn.cutSku)
    // const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(sku)
    // const diff = this._getDifferenceFromMainPackageAndNowPackage(key)
    // const mainPackageDateTime = this._getMainPackageStarDateEndDateText()
    // if (_.isNil(selectedOrderAddOn) && _.isNil(pendingOrderData)) {
    //   return null
    // }
    return (
      <VStack>
        <HStack w='full'>
          <HStack flex={1}>
            <HStack>
              <XText variant='inactive'>{`แพ็กเกจ ${packageName}`}</XText>
              {/* <XText>{`แพ็กเสริม${unit}`}</XText> */}
            </HStack>
            {/* {!_.isNil(mainPackageDateTime) ? (
                <XText variant='inactive' fontSize='xs'>
                  {mainPackageDateTime}
                </XText>
              ) : null} */}
          </HStack>
          <HStack flex={1} justifyContent='flex-end' alignItems='flex-start'>
            <XText>{`${value}`}</XText>
            <XText variant='inactive' fontSize='xs' ml='2' w='70px'>
              {`${unit}`}
            </XText>
          </HStack>
        </HStack>

        {/* {this._renderAddOnCurrentPackageListDetail(key, sku)} */}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderAddOnSelectedTitle = (addOn: { title: string; addOnKey: string; cutSku: string }, sku: string) => {
    const { selectedMainPackage, pendingOrderData, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return null
    }
    let unitCount = selectedMainPackage?.data_json ? selectedMainPackage.data_json[addOn.addOnKey] : 0
    if (mode === 'upgrade') {
      // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
      const newSelectedMainPackage = this._getMainPackageByUpgradePackageMode()
      const { data_json } = newSelectedMainPackage
      unitCount = !_.isNil(data_json) ? data_json[addOn.addOnKey] : 0
    }
    // console.log('unitCount => ', unitCount)
    const getCountFromSelectedAddOn = this._getAddOnCount(addOn)
    unitCount += getCountFromSelectedAddOn
    const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(addOn.cutSku)
    // console.log('addOnKey => ', addOn.addOnKey)
    // console.log('unitCount => ', unitCount)
    // const sectedAddOn = this._getAddOnSelectedData(addOn.cutSku)
    let fontColor = COLORS.TEXT_ACTIVE
    if (!_.isNil(selectedOrderAddOn)) {
      // unitCount += selectedOrderAddOn.data_json[addOn.addOnKey] * sectedAddOn.qty
      fontColor = COLORS.GREEN
    }
    const { title } = addOn
    // const differenceFromMainPackageAndNowPackage = this._getDifferenceFromMainPackageAndNowPackage(addOn.addOnKey)
    const sumTotalAddonCurrentPackage = this._getSumAddonCurrentPackageBillingCycle(addOn.cutSku, addOn.addOnKey)
    // console.log('sumTotalAddonCurrentPackage => ', sumTotalAddonCurrentPackage)
    // const sumtotal = unitCount + diff
    const sumtotal = unitCount + sumTotalAddonCurrentPackage
    return (
      <HStack w='full'>
        <HStack flex={1} alignItems='center'>
          <XText fontSize='lg' bold>
            {title}
          </XText>
        </HStack>
        <HStack flex={1} justifyContent='flex-end' alignItems='center'>
          <XText variant='inactive' fontSize='xs' mr='2'>
            รวม
          </XText>
          <XText color={fontColor} fontSize='lg' bold>
            {`${xFmt.formatDecimal(sumtotal)}`}
          </XText>
          <XText variant='inactive' fontSize='xs' ml='2' w='70px'>
            {title}
          </XText>
        </HStack>
      </HStack>
    )
  }

  _renderSelectedAddOn = (cutSku: string) => {
    const { addOnPackages, pendingOrderData, mode, subscriptionPackageList } = this.state
    const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(cutSku)
    // console.log('addOnPackages => ', addOnPackages)
    // const unit = util.getUnitNameByDataJsonKey(key)
    if (_.isNil(selectedOrderAddOn) || _.isNil(addOnPackages)) {
      return null
    }

    const addOnBySku = this._getAddOnSelectedListData(cutSku)
    // console.log('addOnBySku => ', addOnBySku)
    // console.log('cutSku => ', cutSku)
    if (_.isNil(addOnBySku) || addOnBySku.length === 0) {
      return null
    }

    // const { subscription } = this.props
    return (
      <VStack space='2'>
        {addOnBySku.map((addOn) => {
          const { sku, billing_cycle, qty } = addOn
          // let unitCount = data_json[key]
          // console.log('addOn * => ', addOn)
          const seletedAddOn = this._getAddOnSelectedDataBySku(sku)
          // console.log('addOn => ', addOn)
          // console.log('seletedAddOn => ', seletedAddOn)
          const unitCount = seletedAddOn.data_json[seletedAddOn.item_subtype]
          // console.log('unitCount => ', unitCount)
          const price = seletedAddOn.price_with_vat
          const billingCycle = billing_cycle
          // if (key !== 'order_count_quota') {
          //   billingCycle = billing_cycle
          // }
          const sumTotalPrice = price * billingCycle * qty

          const billingCycleDateTime = util.getStartAndEndBillingCycle(subscriptionPackageList, billing_cycle, mode)
          // let billingCycleDateTime = this._getStartAndEndBillingCycle(billingCycle)
          // if (mode === 'add_on' || mode === 'upgrade') {
          //   const LOCAL_DATE_FORMAT = 'D MMM YYYY'
          //   const startBillingDate = subscription.has('start_billing_date')
          //     ? subscription.get('start_billing_date')
          //     : subscription.get('startBillingDate')
          //   const endBillingDate = subscription.has('end_billing_date')
          //     ? subscription.get('end_billing_date')
          //     : subscription.get('endBillingDate')
          //   const txtEndBillingDate = dayjs(endBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
          //   const txtStartBillingDate = dayjs(startBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
          //   billingCycleDateTime = `${txtStartBillingDate} - ${txtEndBillingDate}`
          // }

          const unitSumCount = _.isNil(unitCount) ? 0 : unitCount
          const unit = util.getUnitNameByDataJsonKey(seletedAddOn.item_subtype)

          // const { future_billing_dates, current_billing_dates } = subscriptionPackageList
          // const startPackage = dayjs(current_billing_dates[0].start, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          // const endDataPackage = dayjs(future_billing_dates[billingCycle - 1].end, 'YYYY-MM-DD')
          //   .clone()
          //   .format('D MMM YYYY')
          return (
            <XCard bgColor={COLORS.BG_LIGHT_GREY} p='2' mx='2' key={addOn.sku}>
              <HStack w='full'>
                <HStack flex={3}>
                  <VStack>
                    <XText color={COLORS.GREEN}>{`ซื้อเพิ่ม ${xFmt.formatDecimal(unitSumCount)} ${unit} x ${qty}`}</XText>
                    <XText variant='inactive' fontSize='xs'>
                      {`${billingCycleDateTime}`}
                    </XText>
                  </VStack>
                </HStack>
                <HStack flex={2} justifyContent='flex-end' alignItems='flex-start'>
                  <XText color={COLORS.GREEN}>{xFmt.formatDecimal(unitSumCount * qty)}</XText>
                  <XText color={COLORS.GREEN} variant='inactive' fontSize='xs' ml='2' w='62px'>
                    {`${unit}`}
                  </XText>
                </HStack>
              </HStack>
              <HStack w='full'>
                <HStack flex={2}>
                  <XText variant='inactive' fontSize='xs'>{`${xFmt.formatCurrency(price)}/รอบบิล x ${billingCycle} รอบบิล x ${qty}`}</XText>
                </HStack>
                <HStack flex={1} justifyContent='flex-end' alignItems='center'>
                  <XText color={COLORS.RED} bold fontSize='lg'>
                    {xFmt.formatCurrency(sumTotalPrice)}
                  </XText>
                </HStack>
              </HStack>
            </XCard>
          )
        })}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderOldAddonList = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const addOnList = this._getAddonCurrentPackageBillingCycle(addOn.cutSku)
    if (_.isNil(addOnList) || addOnList.length === 0) {
      return null
    }

    return (
      <VStack space='2' mt='2'>
        {addOnList.map((addOnx) => {
          const { data_json, start_date, end_date, billing_cycle, qty, sku } = addOnx
          const seletedAddOn = this._getAddOnSelectedDataBySku(sku)
          const unitCount = data_json[addOn.addOnKey]
          const billingCycle = billing_cycle
          // const sumTotalPrice = price * billingCycle * qty
          const billingCycleDateTime = `${dayjs(start_date, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end_date, 'YYYY-MM-DD').format(
            'D MMM YYYY'
          )}`
          const unitSumCount = _.isNil(unitCount) ? 0 : unitCount
          const unit = util.getUnitNameByDataJsonKey(seletedAddOn.item_subtype)
          return (
            <XCard bgColor={COLORS.BG_LIGHT_GREY} p='2' mx='2' key={addOnx.sku}>
              <HStack w='full'>
                <HStack flex={3}>
                  <VStack>
                    <XText variant='inactive'>{`แพ็กเสริมที่ซื้อไปแล้ว ${xFmt.formatDecimal(unitSumCount)} ${unit} x ${qty}`}</XText>
                    <XText variant='inactive' fontSize='xs'>
                      {`${billingCycleDateTime}`}
                    </XText>
                  </VStack>
                </HStack>
                <HStack flex={2} justifyContent='flex-end' alignItems='flex-start'>
                  <XText variant='inactive'>{xFmt.formatDecimal(unitSumCount * qty)}</XText>
                  <XText variant='inactive' fontSize='xs' ml='2' w='62px'>
                    {`${unit}`}
                  </XText>
                </HStack>
              </HStack>
              <HStack w='full'>
                <HStack flex={1}>
                  <XText variant='inactive' fontSize='xs'>{`${billingCycle} รอบบิล x ${qty}`}</XText>
                </HStack>
                {/* <HStack flex={1} justifyContent='flex-end' alignItems='center'>
                  <XText color={COLORS.TEXT_ACTIVE}>{xFmt.formatCurrency(sumTotalPrice)}</XText>
                </HStack> */}
              </HStack>
            </XCard>
          )
        })}
      </VStack>
    )
  }

  _renderOrderCountHistory = (sku: string) => {
    const { orderCountHistory } = this.state
    // console.log('sku => ', sku)
    if (_.isNil(orderCountHistory) || sku !== 'ADDON-QUOTA-ORDER') {
      return null
    }
    let countNumber = 0
    orderCountHistory.forEach((order) => {
      const { order_count } = order
      if (order_count === 0) {
        countNumber += 1
      }
    })
    if (countNumber === orderCountHistory.length) {
      return null
    }
    return (
      <HStack w='full'>
        {/* <TouchableOpacity style={{ paddingBottom: 4 }} onPress={() => this._onPressEditAddOn(sku)}> */}
        <TouchableOpacity style={{ paddingBottom: 4 }} onPress={() => this.setState({ isOrderCountHistory: true })}>
          <XText variant='inactive' textDecorationLine='underline'>
            ดูประวัติการใช้งานออเดอร์
          </XText>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderAddOnView = (addOn: { title: string; addOnKey: string; cutSku: string }) => (
    <VStack w='full' borderBottomColor={COLORS.BG_LIGHT_GREY} borderBottomWidth='1' paddingBottom='2' mt='1' key={addOn.cutSku}>
      <VStack px='2'>
        {this._renderAddOnSelectedTitle(addOn, addOn.cutSku)}
        {this._renderOrderCountHistory(addOn.cutSku)}
        {this._renderAddOnTitle(addOn)}
      </VStack>
      {this._renderSelectedAddOn(addOn.cutSku)}
      {this._renderOldAddonList(addOn)}
    </VStack>
  )

  _showMainPackage = () => {
    const { pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      const { items } = pendingOrderData
      const mainPackage = items.filter((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // console.log('isMainPackage => ', mainPackage)
      if (_.isNil(mainPackage) || mainPackage.length === 0) {
        return false
      }
    }

    return true
  }

  _renderOrderSummaryList = (title: string, billingCycle: number, summary: number | string, mainPackage = false) => {
    const { mode, subscriptionPackageList, selectedMainPackage } = this.state
    if (mode === 'add_on' && mainPackage) {
      return null
    }
    if (mode === 'pending' && mainPackage) {
      const showPackage = this._showMainPackage()
      if (!showPackage) {
        return null
      }
    }
    // const billingCycleDateTime = this._getStartAndEndBillingCycle(billingCycle)
    const pendingModeCheck = subscriptionUtil.pendingModeCheck(selectedMainPackage, mode)
    // console.log('pendingModeCheck => ', pendingModeCheck)
    let billingCycleDateTime = util.getStartAndEndBillingCycle(subscriptionPackageList, billingCycle, pendingModeCheck)
    if (mode === 'add_on') {
      billingCycleDateTime = util.getAddOnModeStartAndEndBillingCycle(subscriptionPackageList, billingCycle)
    }
    return (
      <VStack p='2' w='full' key={title}>
        <VStack w='full'>
          <HStack w='full'>
            <HStack flex={2}>
              <XText>{title}</XText>
            </HStack>
            <HStack flex={1} justifyContent='flex-end'>
              <XText>{xFmt.formatCurrencyFixedPoint(summary, 2)}</XText>
            </HStack>
          </HStack>
          <XText variant='inactive'>{`${billingCycle} รอบบิล (${billingCycleDateTime})`}</XText>
        </VStack>
      </VStack>
    )
  }

  _renderOrderAddOnSummary = () => {
    const ADDON_PACKAGES = this._getAddonPackage()
    if (_.isNil(ADDON_PACKAGES)) {
      return null
    }
    return (
      <VStack>
        {ADDON_PACKAGES.map((addOn) => {
          const { billing_cycle, qty, sku } = addOn
          const selectedPackage = this._getAddOnSelectedDataBySku(sku)
          const name = `${selectedPackage.name} x ${qty}`
          const price = selectedPackage.price_with_vat * qty * billing_cycle
          return this._renderOrderSummaryList(name, billing_cycle, price)
        })}
      </VStack>
    )
  }

  _renderOrderSummaryTotal = () => {
    const { pendingOrderData } = this.state
    if (_.isNil(pendingOrderData)) {
      return null
    }
    const { sub_total_amount, vat_amount, total_amount, wh_tax_amount } = pendingOrderData
    const PRICE_BEFORE_VAT = +sub_total_amount
    const VAT = +vat_amount
    const PRICE_WITH_VAT = +vat_amount + +sub_total_amount
    const TOTAL_PRICE = +total_amount
    const Wh_TEX = +wh_tax_amount
    // console.log('Wh_TEX => ', Wh_TEX)
    return (
      <VStack>
        <HStack borderBottomColor={COLORS.TEXT_ACTIVE} borderBottomWidth='1' borderStyle='dotted' />
        {/* <HStack p='2'>
          <HStack flex={2}>
            <XText bold>รวมยอดคำสั่งซื้อ</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold>{xFmt.formatCurrency(price)}</XText>
          </HStack>
        </HStack> */}
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>ราคาก่อน VAT</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(PRICE_BEFORE_VAT, 2)}</XText>
          </HStack>
        </HStack>
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>VAT 7%</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(VAT, 2)}</XText>
          </HStack>
        </HStack>
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>ราคารวม VAT</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(PRICE_WITH_VAT, 2)}</XText>
          </HStack>
        </HStack>
        {_.isNil(Wh_TEX) || Wh_TEX === 0 ? null : (
          <HStack p='2'>
            <HStack flex={2}>
              <XText variant='inactive'>หักภาษี ณ ที่จ่าย 3%</XText>
            </HStack>
            <HStack flex={1} justifyContent='flex-end'>
              <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(Wh_TEX, 2)}</XText>
            </HStack>
          </HStack>
        )}

        <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' borderStyle='dotted' />

        <VStack bgColor={COLORS.BG_GREY_PACKAGE}>
          <HStack p='2' w='full'>
            <HStack flex={2}>
              <XText bold fontSize='lg'>
                ยอดสุทธิ
              </XText>
            </HStack>
            <VStack flex={1} justifyContent='flex-end'>
              <XText bold fontSize='lg' textAlign='right'>
                {xFmt.formatCurrencyFixedPoint(TOTAL_PRICE, 2)}
              </XText>
              <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' />
              <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='3' mt='1' />
            </VStack>
          </HStack>
        </VStack>
      </VStack>
    )
  }

  _renderOrderSummary = () => {
    const { pendingOrderData, mode } = this.state
    // console.log('pendingOrderData => ', pendingOrderData)
    if (_.isNil(pendingOrderData)) {
      return null
    }
    const mainPackage = this._getMainPackage()
    // console.log('mainPackage => ', mainPackage)
    let name = ''
    let billing_cycle = 0
    let price_with_vat = 0
    if (!_.isNil(mainPackage)) {
      name = mainPackage.name
      billing_cycle = mainPackage.billing_cycle
      price_with_vat = mainPackage.price_with_vat
    }

    return (
      <XCard mx='2' mt='2' flex={1}>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10' w='full'>
          <XText textAlign='center' bold fontSize='lg'>
            {`สรุปคำสั่งซื้อ #${pendingOrderData.id}`}
          </XText>
        </HStack>
        {!_.isNil(mainPackage) ? this._renderOrderSummaryList(name, billing_cycle, price_with_vat, true) : null}
        {this._renderOrderAddOnSummary()}
        {this._renderOrderSummaryTotal()}
      </XCard>
    )
  }

  _renderScbPayment = () => (
    <VStack w='full' alignItems='center' justifyContent='center' m='2'>
      <XCard
        p='2'
        w='72'
        borderWidth='1'
        borderColor={COLORS.SCB_MAIN}
        bgColor='#ECE8F1'
        onPress={() => {
          Clipboard.setString('1623004722')
          p.op.showToast(`คัดลอกเลขบัญชี 1623004722 เรียบร้อยแล้ว`, 'success')
        }}>
        <HStack>
          <HStack w='16'>
            <XImage source={IMG_SCB} w='16' h='16' />
          </HStack>
          <VStack flex={1} ml='2'>
            <XText>ธนาคาร ไทยพาณิชย์ (SCB)</XText>
            <XText>สาขา บางแค</XText>
          </VStack>
        </HStack>
        <VStack w='full' alignItems='center' justifyContent='center'>
          <XText fontSize='md'>บริษัท เอฟฟิลี่ จำกัด</XText>
          <XText fontSize='lg' color={COLORS.SCB_MAIN}>
            162-3-00472-2
          </XText>
          <XText fontSize='xs' textDecorationLine='underline'>
            คัดลอกเลขที่บัญชี
          </XText>
        </VStack>
      </XCard>
    </VStack>
  )

  _renderBankPaymentDropzone = () => {
    // @ts-ignore
    const { selectedFile: sf, uploadedUrl } = this.state

    if (uploadedUrl) {
      return (
        <VStack w='full' p='2' space='2'>
          <XText fontSize='md' bold>
            อัพโหลดหลักฐานการชำระเรียบร้อย
          </XText>
          {/* <XText variant='inactive'>หมายเลขคำสั่งซื้อ #00000001</XText> */}
          {/* <XText variant='inactive' color={COLORS.RED}>
            กรุณารอระบบทำการตรวจสอบหลักฐานการชำระเงินภายใน 30 นาที
          </XText> */}
          {/* <XText variant='inactive' color={COLORS.RED}>
            ระบบจะอัพเดทแพ็กเกจของคุณให้อัตโนมัติ
          </XText> */}

          <TouchableOpacity onPress={() => Linking.openURL(uploadedUrl)}>
            <XText variant='active' style={{ textDecorationLine: 'underline' }}>
              {uploadedUrl}
            </XText>
          </TouchableOpacity>

          {/* <TouchableOpacity
            onPress={() => {
              // @ts-ignore
              this.setState({ uploadedUrl: null, selectedFile: null })
            }}>
            <XText variant='primary'>อัพโหลดใหม่</XText>
          </TouchableOpacity> */}
        </VStack>
      )
    }

    return (
      <VStack w='full' p='2' space='1.5'>
        <XText fontSize='md' bold>
          แนปรูปสลิป
        </XText>
        <XText variant='inactive'>รองรับไฟล์ JPG , PNG , PDF ในการแนบสลิปหลักฐานการชำระ และคลิกปุ่ม 'ยืนยันชำระ' เพื่อยืนยันการชำระ</XText>

        <XDocumentDropzone
          onFileSelect={async (file) => {
            console.log('XDocumentDropzone onDrop file', file)
            // @ts-ignore
            this.setState({ selectedFile: file })
          }}
          acceptFileTypes={['image', 'pdf']}
          renderContent={({ isDragActive, openDocumentPicker }) => (
            <TouchableOpacity onPress={openDocumentPicker}>
              <VStack
                w='full'
                minH='100px'
                p='2'
                alignItems='center'
                justifyContent='center'
                borderWidth='1'
                borderRadius='lg'
                borderColor='primary.500'
                borderStyle='dashed'
                bg={isDragActive ? 'primary.500' : 'primary.100'}>
                {sf && <XText>ไฟล์ที่เลือก...</XText>}
                {sf && (
                  <VStack
                    w='250px'
                    minH='80px'
                    p='1'
                    space='1.5'
                    borderWidth='1'
                    borderRadius='lg'
                    borderColor='muted.400'
                    bg='white'
                    // justifyContent='center'
                    // alignItems='center'
                  >
                    {sf.mime.startsWith('image') && (
                      <XImage
                        source={{ uri: `data:image/png;base64,${sf.data}` }}
                        alt='image'
                        w='50px'
                        h='50px'
                        borderRadius='md'
                        resizeMode='cover'
                      />
                    )}

                    {sf.mime.startsWith('application/pdf') && (
                      <XIcon name='file-pdf-box' family='MaterialCommunityIcons' size='lg' color='red.500' />
                    )}

                    <HStack w='full'>
                      <XText variant='inactive'>
                        ชื่อไฟล์:{' '}
                        <XText variant='active' bold>
                          {sf.name}
                        </XText>
                      </XText>
                    </HStack>
                    <HStack w='full'>
                      <XText variant='inactive'>
                        ชนิดไฟล์: <XText variant='active'>{sf.mime}</XText>
                      </XText>
                    </HStack>

                    <HStack style={{ position: 'absolute', top: -12, right: -12 }}>
                      <XIconButton
                        name='close-circle'
                        onPress={() => {
                          // @ts-ignore
                          this.setState({ selectedFile: null })
                        }}
                      />
                    </HStack>
                  </VStack>
                )}

                {!sf && <XText>วางไฟล์ที่นี่ หรือคลิกที่นี่</XText>}
                {!sf && <XText variant='inactive'>ต้องเป็นไฟล์รูป หรือ pdf เท่านั้น</XText>}
              </VStack>
            </TouchableOpacity>
          )}
        />
        {this._renderDateTimePickerCard()}
        {/* onPress={this._onTestUploadPress} */}
        {/* disabled={!sf} isDisabled={!sf} */}
        {/* {util.isDevMode() ? (
          <XButton onPress={() => this._onSubmitUploadDayAddOne()}>
            <XText>ยืนยันชำระ DAY + 1</XText>
          </XButton>
        ) : null} */}
        <XButton onPress={() => this._onSubmitUpload()}>
          <XText>ยืนยันชำระ</XText>
        </XButton>
      </VStack>
    )
  }

  _renderSumTotalPayment = () => {
    const { pendingOrderData, selectedPaymentChannelIndex } = this.state
    // const price = this._getSumTotalPayment()
    // const whTex = this._getSumTotalWhTex()
    const sumTotalPrice = _.isNil(pendingOrderData) ? 0 : +pendingOrderData.total_amount
    return (
      <HStack w='full' justifyContent='center' alignItems='center' mx='2' mt='2'>
        <XText fontSize='md' bold>
          ยอดสุทธิ
        </XText>
        <VStack w='24' justifyContent='flex-end' mx='2'>
          <XText bold fontSize='md' textAlign='center'>
            {xFmt.formatCurrencyFixedPoint(sumTotalPrice, 2)}
          </XText>
          <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' />
          <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='3' mt='1' />
        </VStack>
        {selectedPaymentChannelIndex === 1 ? (
          <TouchableOpacity
            onPress={() => {
              Clipboard.setString(`${sumTotalPrice}`)
              p.op.showToast(`คัดลอกยอดชำระ ${xFmt.formatCurrencyFixedPoint(sumTotalPrice, 2)} เรียบร้อยแล้ว`, 'success')
            }}
            style={{
              width: 120,
              justifyContent: 'center',
              alignItems: 'center',
              borderWidth: 1,
              borderColor: COLORS.APP_MAIN,
              borderRadius: 90,
              paddingBottom: 6,
              paddingTop: 6,
            }}>
            <XText color={COLORS.APP_MAIN}>คัดลอกยอดชำระ</XText>
          </TouchableOpacity>
        ) : null}
      </HStack>
    )
  }

  _renderDateTimePickerCard = () => {
    const { paymentPostDate } = this.state

    return (
      <VStack w='full'>
        <XText variant='inactive'>เวลาชำระ</XText>
        <HStack w='full' minH='9'>
          <XDateTimeSinglePicker selectedDate={paymentPostDate || new Date()} onChangeDate={this._onChangePaymentPostDate} />
        </HStack>
      </VStack>
    )
  }

  _renderBankPayment = () => {
    const { addOnPackages, pendingOrderData } = this.state
    if (_.isNil(pendingOrderData) && _.isNil(addOnPackages)) {
      return null
    }

    const PAYMENT_BANK_DESCRIPTION = (description: string) => (
      <HStack>
        <HStack w='8' alignItems='flex-start' justifyContent='center'>
          <XIcon name='dot-single' family='Entypo' color={COLORS.TEXT_ACTIVE} />
        </HStack>
        <HStack flex={1}>
          <XText>{description}</XText>
        </HStack>
      </HStack>
    )

    return (
      <XCard mx='2' mt='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10'>
          <XText textAlign='center' bold fontSize='lg'>
            ชำระ
          </XText>
        </HStack>
        <XText ml='2' my='1'>
          ชำระ โอนเงินผ่านบัญชีธนาคาร
        </XText>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='flex-start' h='8'>
          <XText ml='2' textAlign='center' bold>
            คำแนะนำ
          </XText>
        </HStack>
        <VStack my='1' w='full'>
          {PAYMENT_BANK_DESCRIPTION('กรุณาแนบสลิปด้านล่าง (รองรับไฟล์รูปภาพ JPG, PNG และ PDF)')}
          {PAYMENT_BANK_DESCRIPTION('หากรูปแนบมี QR Code ระบบจะสามารถยืนยันการชำระให้ได้อัตโนมัติโดยทันที')}
          {PAYMENT_BANK_DESCRIPTION(
            'หากไฟล์แนบไม่มี QR Code กรุณารอทีมงานตรวจสอบภายใน 3 ชั่วโมงเวลาทำการ (7 AM - 9 PM ทุกวันไม่มีวันหยุด)'
          )}
        </VStack>
        {this._renderScbPayment()}
        {this._renderSumTotalPayment()}
        {this._renderBankPaymentDropzone()}
      </XCard>
    )
  }

  _renderQrcodePaymentImg = () => {
    const { qrCodeObject } = this.state
    // const QR_CODE =
    //   'data:image/gif;base64,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'

    // console.log('qrCodeObject => ', qrCodeObject)
    const QR_CODE_VIEW = () => (
      <VStack>
        <XImage source={{ uri: `data:image/gif;base64,${qrCodeObject.qr_image}` }} style={{ width: 250, height: 250 }} />
        <XText textAlign='center' mt='2' variant='inactive'>
          {`หมายเลขการโอน: ${qrCodeObject.order_id}`}
        </XText>
      </VStack>
    )
    const BTN_REQUEST_QR_CODE = () => (
      <VStack alignItems={'center'} justifyContent='center'>
        <XIcon name='qrcode-scan' family='MaterialCommunityIcons' color={COLORS.TEXT_INACTIVE} size={'lg'} />
        <XText variant='inactive' mt='2'>
          กดปุ่ม "สร้าง QR Code" เพื่อสร้าง QR Code สำหรับการชำระ
        </XText>
        <TouchableOpacity
          // eslint-disable-next-line react/no-this-in-sfc
          onPress={() => this._requestQrCode()}
          style={{
            backgroundColor: COLORS.APP_MAIN,
            borderRadius: 90,
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            marginTop: 8,
            width: 140,
          }}>
          <XText color={COLORS.WHITE} textAlign={'center'}>
            สร้าง QR Code
          </XText>
        </TouchableOpacity>
      </VStack>
    )
    return (
      <VStack w='full' alignContent='center' justifyContent='center' alignItems='center' mt='2'>
        <HStack mt='2'>{_.isNil(qrCodeObject) ? BTN_REQUEST_QR_CODE() : QR_CODE_VIEW()}</HStack>
        {_.isNil(qrCodeObject) ? null : (
          <VStack mt='2'>
            <HStack>
              <XText bold>QR Code จะหมดอายุภายใน </XText>
              <XCountdownTimer
                expiryDate={qrCodeObject.expiry_date}
                expiredText='QR Code หมดอายุ'
                showHours={false}
                showDays={false}
                expiredCallBack={() =>
                  this.setState({
                    qrCodeObject: null,
                  })
                }
              />
              {/* <XText bold> นาที</XText> */}
            </HStack>
            <XText color={COLORS.RED} textAlign='center'>
              ** สแกนชำระได้ครั้งเดี่ยว (ห้ามชำระซ้ำ) **
            </XText>
          </VStack>
        )}
        {!_.isNil(qrCodeObject) ? (
          <TouchableOpacity
            onPress={() => this._downloadQrImage(qrCodeObject.qr_image)}
            style={{
              // backgroundColor: COLORS.APP_MAIN,
              // borderRadius: 90,
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 10,
            }}>
            <XText color={COLORS.TEXT_INACTIVE} textDecorationLine='underline'>
              ดาวน์โหลด QR Code
            </XText>
          </TouchableOpacity>
        ) : null}
      </VStack>
    )
  }

  _renderQrcodePayment = () => {
    const { addOnPackages, pendingOrderData } = this.state
    if (_.isNil(pendingOrderData) && _.isNil(addOnPackages)) {
      return null
    }

    const PAYMENT_BANK_DESCRIPTION = (description: string, fontColor?: string) => (
      <HStack>
        <HStack w='8' alignItems='flex-start' justifyContent='center'>
          <XIcon name='dot-single' family='Entypo' color={COLORS.TEXT_ACTIVE} />
        </HStack>
        <HStack flex={1}>
          <XText color={_.isNil(fontColor) ? COLORS.TEXT_ACTIVE : fontColor}>{description}</XText>
        </HStack>
      </HStack>
    )

    return (
      <XCard mx='2' mt='2' pb='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10'>
          <XText textAlign='center' bold fontSize='lg'>
            ชำระ
          </XText>
        </HStack>
        <HStack w='full'>
          <XText ml='2' mb='1' mt='2'>
            กรุณาเปิดแอปธนาคารของท่าน เพื่อสแกน QR Code ด้านล่าง
          </XText>
        </HStack>
        {/* <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='flex-start' h='8'>
          <XText ml='2' textAlign='center' bold>
            คำแนะนำ
          </XText>
        </HStack> */}
        {this._renderSumTotalPayment()}
        {this._renderQrcodePaymentImg()}
        <VStack my='1' w='full' mt='2'>
          {PAYMENT_BANK_DESCRIPTION('รองรับแค่แอปธนาคารเท่านั้น (ไม่รับ ทรูมันนี่ แอปเป๋าตัง และอื่นๆ)')}
          {PAYMENT_BANK_DESCRIPTION('หากสแกนชำระแล้วกรุณารอสักครู่ ขณะที่ระบบกำลังทำรายการ')}
        </VStack>

        {/* {this._renderBankPaymentDropzone()} */}
      </XCard>
    )
  }

  _renderPaymentChannels = () => {
    const { selectedPaymentChannelIndex } = this.state
    return (
      <XCard mx='2' mt='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10'>
          <XText textAlign='center' bold fontSize='lg'>
            วิธีการชำระ
          </XText>
        </HStack>
        <HStack w='full' flexWrap='wrap' space='2' p='2'>
          {this.SELECTED_PAYMENT_CHANNELS_INDEX.map((channel) => {
            const { index, label, prefixIcon } = channel
            return (
              <XCheckButton
                key={`XCheckButton_${index}`}
                // buttonStyle={{ marginTop: 2 }}
                checked={index === selectedPaymentChannelIndex}
                name={label}
                label={label}
                data={index}
                onPress={(onPressData) => {
                  // console.log('data => ', onPressData)
                  this.setState({ selectedPaymentChannelIndex: onPressData.data })
                }}
                prefixIcon={prefixIcon}
              />
            )
          })}
        </HStack>
      </XCard>
    )
  }

  _renderCancelSubscriptionOrder = () => {
    const { pendingOrderData } = this.state
    if (_.isNil(pendingOrderData)) {
      return null
    }
    return (
      <HStack w='full' p='2' justifyContent='center'>
        <TouchableOpacity style={{ justifyContent: 'center', height: 32 }} onPress={() => this._cancelPendingOrder()}>
          <XText textDecorationLine='underline' color={COLORS.RED}>
            ยกเลิกคำสั่งซื้อ
          </XText>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderPaymentMethod = () => {
    const { selectedPaymentChannelIndex } = this.state
    if (selectedPaymentChannelIndex === 0) {
      return this._renderQrcodePayment()
    }
    if (selectedPaymentChannelIndex === 1) {
      return this._renderBankPayment()
    }
    return null
  }

  render() {
    const { isLoading } = this.state
    return (
      <XContainer>
        {this._renderHeader()}
        <XContent>
          <VStack bgColor={COLORS.WHITE}>
            {/* {this._renderProfile()} */}

            {this._renderOrderSummary()}
            {this._renderPaymentChannels()}
            {this._renderPaymentMethod()}
            {this._renderCancelSubscriptionOrder()}
            <HStack h='8' />
            {isLoading ? (
              <VStack
                alignItems='center'
                justifyContent='center'
                bg='gray.400:alpha.50'
                style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}>
                <XSpinner />
              </VStack>
            ) : null}
          </VStack>
        </XContent>
      </XContainer>
    )
  }
}
